"use client";

import React, { createContext, useEffect, useMemo, useState } from "react";

interface Props {
  children: React.ReactNode;
}

type Theme = "light" | "dark";
export const ThemeContext = createContext<Theme>("dark");

export default function ThemeWrapper({ children }: Props) {
  //Get currentTheme from localStorage

  const [theme, setTheme] = useState<Theme>("dark");

  useEffect(() => {
    function getTheme() {
      const currentTheme = localStorage.getItem("theme") as Theme;
      if (currentTheme) setTheme(currentTheme);
    }

    addEventListener("storage", getTheme);

    return () => {
      removeEventListener("storage", getTheme);
    };
  }, []);

  return (
    <div
      className={`theme-${theme} flex flex-col bg-c-bg h-screen overflow-auto text-c-dark`}
    >
      <ThemeContext.Provider value={useMemo(() => theme, [theme])}>
        {children}
      </ThemeContext.Provider>
    </div>
  );
}
